<template>
  <div class="kecheng">
    <div class="dis_flex_between">
      <el-radio-group
        v-show="search.IsPurchase == 1"
        v-model="search.isSingle"
        class="redRadio"
        @change="searchClick"
      >
        <el-radio :label="0">资料包</el-radio>
        <el-radio :label="1">资料</el-radio>
      </el-radio-group>
    </div>
    <!-- 学习资料 -->
    <div class="content">
      <!-- 学习资料 -->
      <div v-if="list && list.length > 0" class="list-two">
        <div v-for="(item, index) in list" :key="index" class="item">
 
          <img
            v-show="search.isSingle == 0"
            class="item-img"
            src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/fileIcon.png"
          />
          <div v-show="search.isSingle == 1" class="itemImgBox">
            <img
              v-if="item.filetype == 'excel'"
              class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataXls.png"
            />
            <img
              v-else-if="item.filetype == 'word'"
              class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataDoc.png"
            />
            <img
              v-else-if="item.filetype == 'pdf'"
              class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataPdf.png"
            />
            <img
              v-else-if="item.filetype == 'ppt'"
              class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataPpt.png"
            />
            <img
              v-else
              class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataFile.png"
            />
          </div>
          <div class="item-content">
            <div class="item-text twoEllipsis">{{ item.materialPackageName }}</div>
            <div v-show="search.isSingle == 0" class="item-num">
              共{{ item.materialAmount ? item.materialAmount : 0 }}份资料
            </div>
            <!-- <div class="item-size">{{ item.size }}</div> -->
          </div>

          <div
            style="height: auto"
            class="keep-learn fles-shrink"
            @click="toMaterialPage(item)"
          >
            查看资料
          </div>
        </div>
      </div>
      <!-- 暂无课程 -->
      <div v-if="!list || list.length == 0" class="nothing">
        <div class="nothing-text">暂无内容哦~</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import { DataClient } from '@/api/dataClient'
// const dataClient = new DataClient()
import { getInfo } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},

  data() {
    return {
      list: {},
      search: {
        IsPurchase: 1, // 1 赠送  0 购买
        isSingle: 0, // 0资料包 1 资料
      },
      pageSize: 8,
      pageNum: 1,
      total: 0,
      userInfo: null,
      kowledgePointsVisible: false,
    };
  },
  created() {
    this.userInfo = getInfo();
    this.getList();
  },
  methods: {
    // 获取知识套餐列表
    getList() {
      homeClient.getMaterialBuyList({}).then((res) => {
        if (this.search.isSingle == 0) {
          this.list = res.data.materialPackageList || [];
        } else {
          this.list = res.data.materialList || [];
        }
        console.log(this.list);
      });
    },

    /* ----------------------------------------------------- */
    isOk(val) {
      this.search = val;
      this.getList();
    },
    // 点击图片跳转到详情页
    checkClick(item) {
      this.$router.push(`/data/dataPackageDetail?packageId=${item.coursesId}`);
    },
    /* 赠送/购买筛选 */
    btnClick(val) {
      this.pageNum = 1;
      this.list = [];
      this.total = 0;
      this.search.IsPurchase = val;
      this.search.isSingle = 0;
      this.getList();
    },
    /* 资料/资料包筛选 */
    searchClick() {
      this.pageNum = 1;
      this.list = [];
      this.total = 0;
      this.getList();
    },
    /* 点击查看资料 */
    toMaterialPage(item) {
      if (this.search.isSingle == 0) {
        this.$router.push({
          path: `/data/materialPage`,
          query: {
            id: item.id,
            title: item.materialPackageName, 
          },
        });
      } else {
        // const data = {
        //   zlId: item.mid,
        //   xmId: item.kind,
        //   linkLocation: item.names,
        //   type: 1,
        // };
        // dataClient.downloadRecord(data);
        Vue.prototype.DownloadDoc(item.uploadMaterial, item.materialPackageName)
        // this.$router.push({
        //   path: "/VIP/sourcePage",
        //   query: {
        //     seeNum: item.seeNum,
        //     names: item.names,
        //     id: this.id,
        //     title: this.title,
        //     schoolId: this.schoolId,
        //     type: 2,
        //     IsPurchase: this.IsPurchase != 1,
        //   },
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.kecheng {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #ffffff;
  padding-bottom: 20px;

  .dis_flex_between {
    padding: 24px 32px;
    background: #fff;

    .btnBox {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;

      .btnItem {
        cursor: pointer;
      }

      .on {
        color: #ff5e51;
      }
    }
  }

  .content {
    min-height: calc(100% - 124px - 27px);
    overflow-y: scroll;

    .list-two {
      padding: 0px 32px;
    }

    .item {
      border-radius: 0px;
      border-bottom: 1px solid #eee;
      margin-bottom: 0px;

      .itemImgBox {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;

        .imgItem {
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
      }

      .btn {
        color: #666666;
        border: 1px solid #666666;
        border-radius: 4px;
        font-size: 14px;
        padding: 0 16px;
        line-height: 28px;
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }
}

.list-two {
  padding: 0px;
  background: #fff;
}

.item-size {
  font-size: 12px;
}

.kowledgePoints_wrap {
  padding-bottom: 20px;

  .determine_btn {
    width: 40%;
    height: 40px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #ff5e51;
    color: #ffffff;
    font-weight: 500;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
